var TaskTypes;
(function (TaskTypes) {
    TaskTypes[TaskTypes["assign"] = 'Assign'] = "assign";
    TaskTypes[TaskTypes["createDispute"] = 'Create Dispute'] = "createDispute";
    TaskTypes[TaskTypes["createOpportunity"] = 'Create Opportunity'] = "createOpportunity";
    TaskTypes[TaskTypes["changeStatus"] = 'Change Status'] = "changeStatus";
})(TaskTypes || (TaskTypes = {}));
var EsLogsDetailsController = (function () {
    function EsLogsDetailsController(settings, env, $compile, $filter, socket, $scope, $state, $stateParams, $http, Dialog, notify, moment) {
        var _this = this;
        this.settings = settings;
        this.env = env;
        this.$compile = $compile;
        this.$filter = $filter;
        this.socket = socket;
        this.$scope = $scope;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$http = $http;
        this.Dialog = Dialog;
        this.notify = notify;
        this.moment = moment;
        this.isDetailsOpen = true;
        this.areStepsOpen = false;
        this.showUnhandledTasks = false;
        this.unprocessedNumber = 0;
        this.id = '';
        this.doc = {};
        this.checkboxModel = {
            value1: true,
            value2: 'YES'
        };
        this.tasks = [];
        this.backendModuleName = 'admin/eslogs/esLogs';
        this.scopePrefix = 'admin.eslogs';
        this.scopeGetTasks = this.scopePrefix + ".getTasks";
        this.handleDetailsClick = function (task) {
            task.isDetailsOpen = !task.isDetailsOpen;
        };
        this.handleStepsClick = function (task) {
            task.areStepsOpen = !task.areStepsOpen;
        };
        this.handleShowHideUnhadledClick = function () {
            _this.showUnhandledTasks = !_this.showUnhandledTasks;
        };
        this.id = $stateParams.id;
        this.socket.forward(this.scopeGetTasks, this.$scope);
        this.$scope.$on("socket:" + this.scopeGetTasks, function (event, data) {
            if (_this.isIncomingErrors(data)) {
                _this.handleIncomingErrors(data.error, 'Create a record');
                _this.notify.error("Unable to create a record");
            }
            else {
                _this.tasks = data.tasks;
                _this.tasks.forEach(function (task) {
                    task.body = JSON.stringify(task.body, undefined, 4);
                    task.taskType = TaskTypes[task.taskType];
                    task.updated = task.updated ? _this.moment(task.updated).format('MM/DD/YYYY HH:mm:ss') : '';
                    task.created = task.created ? _this.moment(task.created).format('MM/DD/YYYY HH:mm:ss') : '';
                });
                _this.unprocessedNumber = _this.tasks.filter(function (task) { return task.taskStatus === 'unprocessed'; }).length;
                _this.doc = JSON.stringify(data.doc, undefined, 4);
                _this.notify.success('Record successfuly added');
            }
        });
    }
    EsLogsDetailsController.prototype.$onInit = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                data: { id: this.id },
                email: this.env.user.email,
                function: 'getTasks',
                scopeBack: this.scopeGetTasks,
                script: this.backendModuleName,
                token: this.env.user.token
            }
        });
    };
    EsLogsDetailsController.prototype.isIncomingErrors = function (data) {
        if (data && data.error) {
            if (data.error.validationErrors.length || data.error.errors.length) {
                return true;
            }
        }
        else {
            return false;
        }
    };
    /**
     * Function to show all errors
     */
    EsLogsDetailsController.prototype.handleIncomingErrors = function (data, name) {
        var allErrorsInfo = {
            allErrors: data,
            windowName: name
        };
        this.Dialog.showingErrors(event, allErrorsInfo, 'showing-errors.html').then(function (dResult) {
            if (dResult) {
                return;
            }
        });
        return;
    };
    EsLogsDetailsController.$inject = [
        'settings',
        'env',
        '$compile',
        '$filter',
        'socket',
        '$scope',
        '$state',
        '$stateParams',
        '$http',
        'Dialog',
        'notify',
        'moment'
    ];
    return EsLogsDetailsController;
}());
var EsLogsDetailsComponent = (function () {
    function EsLogsDetailsComponent() {
        this.templateUrl = 'eslogs-details.html';
        this.controllerAs = 'vm';
        this.controller = EsLogsDetailsController;
    }
    return EsLogsDetailsComponent;
}());
angular
    .module('application')
    .config(function ($mdIconProvider) {
    $mdIconProvider.icon('processed', '/public/icons/checkmark--filled--32.svg');
    $mdIconProvider.icon('unprocessed', '/public/icons/help--filled--32.svg');
    $mdIconProvider.icon('failed', '/public/icons/misuse--32.svg');
})
    .component('eslogsDetailsSection', new EsLogsDetailsComponent());

//# sourceMappingURL=eslogs-details.component.js.map
